import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";

import { qasApi } from "./RTKQuery/qasSlice";
import rootReducer from "./rootReducer";
import { clsApi } from "./RTKQuery/clsSlice";

export const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(qasApi.middleware, clsApi.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
